import { useState, useContext, useEffect } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import InputGroupForm from "../../Components/InputGroup/InputGroupForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import {
  CommonDropdownData,
  loanModuleGetPersonalDetailsByMemberId,
  getSuretyDetailsByMemberId,
  getSuretyDetailsForApproval,
  postSuretyDetails,
  postLoanRequestStatus,
} from "../../Helpers/APIEndPoints/EndPoints";
import { Decrypt } from "../../Helpers/Cryptography/Crypto";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonComponent from "../../Components/ButtonForm/Button";
import "./style.css";
import { LoanTypeEnum, MODES } from "../../Helpers/Enums/Enum";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsCheckCircle } from "react-icons/bs";
import { PiClockBold } from "react-icons/pi";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useSelector } from "react-redux";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";

const SurityDetails = (props) => {
  const { selectNextTab } = props;
  const context = getContext();
  const { state } = useLocation();

  let navigate = useNavigate();
  let MemberId = context.MemberId;
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [approvalStatus, setApprovalStatus] = useState();
  const [suretyApprovalStatus, setSuretyApprovalStatus] = useState();

  // let Lo anRequestId = JSON.parse(
  //   Decrypt(localStorage.getItem("Lo anRequestId"))
  // );

  const [formErrors, setFormErrors] = useState({});
  const [name, setName] = useState("");
  const [id1, setId1] = useState(0);
  const [loanTypeSuretyId, setLoanTypeSuretyId] = useState();
  const [surityStatus, setSurityStatus] = useState<any>();
  const [memberNumber, setMemberNumber] = useState<any>();
  const [tokenNumber, setTokenNumber] = useState<any>();

  const [memberNumber2, setMemberNumber2] = useState("");
  const [id2, setId2] = useState(0);
  const [name2, setName2] = useState<any>();
  const [tokenNumber2, setTokenNumber2] = useState<any>();
  const [surityStatus2, setSurityStatus2] = useState("");

  const [disabled, setDisabled] = useState(true);
  const [memberDisabled, setMemberDisabled] = useState(false);
  const [memberDisabled2, setMemberDisabled2] = useState(false);
  const [surety2, setSurety2] = useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const loanParameters = useSelector<any>(
    (states) => states?.LoanModuleReducer
  );

  let formErrorObj = {};

  useEffect(() => {
    // if (state.Id != 0 && state != null) {
    getPersonalDetailsById();
    if (loanTypeSuretyId != 0) {
      getPersonalDetailsByIdApiCallll();
    }
    // }
  }, [loanTypeSuretyId]);

  const getPersonalDetailsById = async () => {
    showLoader();
    let requestParams = loanParameters?.["loanParameters"]; // { MemberId: MemberId };

    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    
    if (res.Message === "Ok" && res.Data !== null) {
      switch (res?.Data?.Lrd_StatusId) {
        case LoanStatus.LoanModule_AllSuretyApproved:
        case LoanStatus.LoanModule_RejectedByInternalTeam:
          setButtonDisabled(false);
          break;
        default:
          // Handle default case if needed
          break;
      }
      if (res?.Data?.Lrd_LoanType === LoanTypeEnum.LONGTERM) {
        setSurety2(true);
      }
      setLoanTypeSuretyId(res?.Data?.Lrd_LoanType);
      setApprovalStatus(res?.Data?.Lrd_StatusId);
      setSuretyApprovalStatus(res?.Data?.Lrs_StatusId);

      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  const onChange = (key: any, value: any) => {
    // let value = val.target.value;
    if (key == "memberNumber") {
      setMemberNumber(value);
    }
    // if (key == "tokenNumber") {
    //   setTokenNumber(value);
    // }
    // if (key == "tokenNumber") {
    //   setTokenNumber(value);
    // }

    if (key == "memberNumber2") {
      setMemberNumber2(value);
    }
    // if (key == "tokenNumber2") {
    //   setTokenNumber2(value);
    // }
    // if (key == "tokenNumber2") {
    //   setTokenNumber2(value);
    // }
  };

  const onClickHandler = () => {
    getMemberDetailsByIdApiCall(memberNumber, "memberNumber");
  };
  const onClickHandler2 = () => {
    getMemberDetailsByIdApiCall(memberNumber2, "memberNumber2");
  };

  const onSubmitValidation = async () => {
    setFormErrors({});
    formErrorObj = {};

    if (!memberNumber || memberNumber === "") {
      formErrorObj["memberNumber_isEmpty"] =
        "Member Number can not be empty or Zero(0)";
    }

    if (!name || name === "") {
      formErrorObj["name_isEmpty"] = "name can not be empty";
    }

    if (!tokenNumber || tokenNumber === "" || tokenNumber <= 0) {
      formErrorObj["tokenNumber_isEmpty"] =
        "Token number can not be empty or Zero(0)";
    }

    if (surety2 || memberNumber2 !== "") {
      if (!memberNumber2 && memberNumber2 === "") {
        formErrorObj["memberNumber2_isEmpty"] =
          "Member Number can not be empty or Zero(0)";
      }

      if (!name2 || name2 === "") {
        formErrorObj["name2_isEmpty"] = "name can not be empty";
      }

      if (!tokenNumber2 || tokenNumber2 === "" || tokenNumber2 <= 0) {
        formErrorObj["tokenNumber2_isEmpty"] =
          "Token number can not be empty or Zero(0)";
      }
    }

    setFormErrors(formErrorObj);
  };

  const getMemberDetailsByIdApiCall = async (memberNo, key) => {
    showLoader();
    let requestParams = {
      MemberId: memberNo,
      LoanTypeId: loanTypeSuretyId,
      SuretyUserId: context.Id,
    };
    const res = await APICall(getSuretyDetailsByMemberId, requestParams);

    if (res.Status === ApiStatus.OK && res.Data !== null) {
      setDisabled(true);
      if (key == "memberNumber") {
        setTokenNumber(res?.Data?.TokenNo);
        setName(res?.Data?.FullName);

        formErrorObj["memberNumber_isEmpty"] = null;
        formErrorObj["name_isEmpty"] = null;
        formErrorObj["tokenNumber_isEmpty"] = null;
      }
      if (key == "memberNumber2") {
        setTokenNumber2(res?.Data?.TokenNo);
        setName2(res?.Data?.FullName);
        formErrorObj["memberNumber2_isEmpty"] = null;
        formErrorObj["name2_isEmpty"] = null;
        formErrorObj["tokenNumber2_isEmpty"] = null;
      }
      setFormErrors(formErrorObj);
    } else {
      if (key == "memberNumber") {
        setTokenNumber("");
        setName("");
      }
      if (key == "memberNumber2") {
        setTokenNumber2("");
        setName2("");
      }
      // notify(ToastType.Error, "Member Detail Not Found");
      notify(
        ToastType.Error,
        res?.Message.toLowerCase() == "OK".toLowerCase()
          ? "Member Detail Not Found"
          : res?.Message
      );
    }
    hideLoader();
  };

  const getPersonalDetailsByIdApiCallll = async () => {
    showLoader();
    let requestParams = {
      LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
    };

    const res = await APICall(getSuretyDetailsForApproval, requestParams);

    if (res.Message === "Ok" && res?.Data?.length > 0) {
    
      if (
        [LoanStatus.LoanModule_SuretyRejectedByMember].includes(
          res?.Data[0]?.Lrs_Status
        )
      ) {
        setMemberDisabled(false);
      } else {
        setMemberDisabled(true);
      }
      if (
        [LoanStatus.LoanModule_SuretyRejectedByMember].includes(
          res?.Data[1]?.Lrs_Status
        )
      ) {
        setMemberDisabled2(false);
      } else {
        setMemberDisabled2(true);
      }

      setDisabled(true);

      setSurityStatus(res?.Data[0]?.Lrs_Status);
      setMemberNumber(res?.Data[0]?.MemberNo);
      setTokenNumber(res?.Data[0]?.TokenNo);
      setName(res?.Data[0]?.FullName);
      setId1(res?.Data[0]?.Lrs_Id);

      if (res?.Data[1]?.MemberNo) {
        setId2(res?.Data[1]?.Lrs_Id);
        setMemberNumber2(res?.Data[1]?.MemberNo);
        setTokenNumber2(res?.Data[1]?.TokenNo);
        setName2(res?.Data[1]?.FullName);
        setSurityStatus2(res?.Data[1]?.Lrs_Status);
      }
      
      if (loanTypeSuretyId === LoanTypeEnum.LONGTERM) {
        if (
          LoanStatus.LoanModule_SuretyAcceptedByMember ==
            res?.Data[0]?.Lrs_Status &&
          LoanStatus.LoanModule_SuretyAcceptedByMember ==
            res?.Data[1]?.Lrs_Status
        ) 
        {
          setButtonDisabled(false);
        }
        
        // if (
        //   LoanStatus.LoanModule_SuretyAcceptedByMember ==
        //   res?.Data[0]?.Lrs_Status
        // ) {
        //   setButtonDisabled(false);
        // }
      }
    } else {
      setMemberDisabled(false);
      setMemberDisabled2(false);
    }
    hideLoader();
  };

  const SurityStatus = ({ SurStatus }) => {
    if (LoanStatus.LoanModule_SuretyApprovalPending == SurStatus) {
      return (
        <div
          className="reg-status-container reg-status-container-pending"
          style={{ width: "35%", borderRadius: "31px" }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <PiClockBold
              className="reg-status-icon reg-status-icon-pending mx-2"
              style={{ fontSize: "18px" }}
            />
            <span
              className="reg-status-text reg-status-text-pending"
              style={{ fontSize: "16px" }}
            >
              Pending
            </span>
          </div>
        </div>
      );
    } else if (LoanStatus.LoanModule_SuretyAcceptedByMember == SurStatus) {
      return (
        <div
          className="reg-status-container reg-status-container-approved"
          style={{ width: "35%", borderRadius: "31px" }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <BsCheckCircle
              className="reg-status-icon reg-status-icon-approved mx-2"
              style={{ fontSize: "18px" }}
            />
            <span
              className="reg-status-text reg-status-text-approved"
              style={{ fontSize: "16px" }}
            >
              Approved
            </span>
          </div>
        </div>
      );
    } else if (LoanStatus.LoanModule_SuretyRejectedByMember == SurStatus) {
      return (
        <div
          className="reg-status-container reg-status-container-rejected"
          style={{ width: "35%", borderRadius: "31px" }}
        >
          <div className="d-flex justify-content-center align-items-center">
            <AiOutlineCloseCircle
              className="reg-status-icon reg-status-icon-rejected mx-2"
              style={{ fontSize: "18px" }}
            />
            <span
              className="reg-status-text reg-status-text-rejected"
              style={{ fontSize: "16px" }}
            >
              Rejected
            </span>
          </div>
        </div>
      );
    }
  };

  const onProceed = async () => {
    let param = {
      //StatusId: LoanStatus.LoanModule_PendingWithInternalTeam, 
      StatusId: LoanStatus.LoanModule_PendingWithHrHOD,
      LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
      UserIdApproval: context?.Id,
      MemberId: MemberId,
    };

    let resp = await APICall(postLoanRequestStatus, param);
    if (resp?.Status == ApiStatus.OK) {
      navigate("/LoanApprovalDashboard");
      //notify(ToastType.Success, "Loan Approval Pending With Internal Team");
      notify(ToastType.Success, "Loan Approval Pending With HR/HOD");
    } else {
      notify(ToastType.Error, resp?.Message || "Please try again later.");
      return;
    }
    hideLoader();
  };

  const onSubmit = async () => {
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    // if (surety2) {
    //   if (memberDisabled && memberDisabled2) {
    //     navigate("/LoanApprovalDashboard");
    //     return;
    //   }
    // } else {
    //   if (memberDisabled) {
    //     navigate("/LoanApprovalDashboard");
    //     return;
    //   }
    // }

    if (isEmpty === true) {
      if (memberNumber2 == memberNumber) {
        notify(
          ToastType.Error,
          "Duplicate Member Numbers are not allowed. Please enter a different Member Number."
        );
        return;
      }
      showLoader();

      let rejectReq =
        LoanStatus.LoanModule_SuretyRejectedByMember === parseInt(surityStatus);
      let rejectReq2 =
        LoanStatus.LoanModule_SuretyRejectedByMember ===
        parseInt(surityStatus2);

      let memberNumbersToSend;
      let IdNumbersToSend;
      let Sequence;

      if (surityStatus == "" && surityStatus2 == "") {
        // If both surityStatus and surityStatus2 are empty
        memberNumbersToSend = [memberNumber, memberNumber2];
        IdNumbersToSend = [id1, id2];
        Sequence = [1, 2];
      } else if (rejectReq && rejectReq2) {
        // If both surityStatus and surityStatus2 are LoanModule_SuretyRejectedByMember
        memberNumbersToSend = [memberNumber, memberNumber2];
        IdNumbersToSend = [id1, id2];
        Sequence = [1, 2];
      } else if (rejectReq2) {
        // If surityStatus2 is LoanModule_SuretyRejectedByMember
        memberNumbersToSend = [memberNumber2];
        IdNumbersToSend = [id2];
        Sequence = [2];
      } else if (rejectReq) {
        // If surityStatus is LoanModule_SuretyRejectedByMember
        memberNumbersToSend = [memberNumber];
        IdNumbersToSend = [id1];
        Sequence = [1];
      } else {
        // Default case, if none of the above conditions are met
        memberNumbersToSend = [memberNumber, memberNumber2];
        IdNumbersToSend = [id1, id2];
        Sequence = [1, 2];
      }

      let param = {
        MemberNumbers: memberNumbersToSend.filter((e) => e).join(","),
        StatusId: LoanStatus.LoanModule_SuretyApprovalPending,
        LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
        SurityIds: IdNumbersToSend.join(","),
        LoanTypeId: loanTypeSuretyId,
        Sequence: Sequence.join(","),
        MemberId: MemberId,
      };
      // surityStatus
      // surityStatus2

      let resp = await APICall(postSuretyDetails, param);
      if (resp?.Status == ApiStatus.OK) {
        notify(ToastType.Success, "Waiting for surety approval");
        getPersonalDetailsByIdApiCallll();
        getPersonalDetailsById();
      } else {
        notify(ToastType.Error, resp?.Message || "Please try again later.");
        hideLoader();
        return;
      }
      hideLoader();
    }
    hideLoader();
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  return (
    <div className="p-0">
      <div className="col-lg-12 col-md-12">
        <div
          className="row"
          style={{ marginLeft: "-30px", marginRight: "-30px" }}
        >
          <div className="col-lg-12 col-sm-12 col-xs-12 ">
            <div className="form-group"></div>
            <p className="Surity">
              Surety 1 <sup>*</sup>
            </p>
          </div>
        </div>
        <div
          className="row"
          style={{ marginLeft: "-30px", marginRight: "-30px" }}
        >
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <div className="form-group">
              <label>Member Number</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <InputGroupForm
                alignment="right"
                onClick={onClickHandler}
                ButtonName="Apply"
                placeholder={"Enter Member Number"}
                style={{ borderRadius: "3px 0px 0px 3px" }}
                value={memberNumber}
                onChange={(val: any) => {
                  let value = val.target.value;
                  const regex = /^[0-9]/;
                  if (value === "" || regex.test(value)) {
                    onChange("memberNumber", value);
                  }
                }}
                type="number"
                isDisabled={memberDisabled}
                onKeyPress={(e) => handleKeyPress(e)}
                onWheel={(e) => e.target.blur()}
              />
              <p style={{ color: "red" }}>
                {formErrors["memberNumber_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <div className="form-group">
              <label>Token Number</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <InputForm
                placeholder={"Token Number"}
                value={tokenNumber}
                // onChange={(val: any) => {
                //   onChange("tokenNumber", val);
                // }}
                isDisabled={disabled}
              />
              {/* <p style={{ color: "red" }}>
                {formErrors["tokenNumber_isEmpty"]}
              </p> */}
            </div>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <div className="form-group">
              <label>Name</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <InputForm
                placeholder={"Name"}
                value={name}
                // onChange={(val: any) => {
                //   onChange("name", val);
                // }}
                isDisabled={disabled}
              />
              {/* <p style={{ color: "red" }}>{formErrors["name_isEmpty"]}</p> */}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "-10px 0px 0px 0px",
                height: "25px",
              }}
            >
              <SurityStatus SurStatus={surityStatus} />
            </div>
          </div>
        </div>
        {surety2 ? (
          <>
            <div
              className="row"
              style={{ marginLeft: "-30px", marginRight: "-30px" }}
            >
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group"></div>
                <p className="Surity">
                  Surety 2 <sup>*</sup>
                </p>
              </div>
            </div>
            <div
              className="row"
              style={{ marginLeft: "-30px", marginRight: "-30px" }}
            >
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <div className="form-group">
                  <label>Member Number</label>
                  <sup>*</sup>
                  <InputGroupForm
                    alignment="right"
                    onClick={onClickHandler2}
                    ButtonName="Apply"
                    placeholder={"Enter Member Number"}
                    value={memberNumber2}
                    style={{ borderRadius: "3px 0px 0px 3px" }}
                    onChange={(val: any) => {
                      let value = val.target.value;
                      const regex = /^[0-9]/;
                      if (value === "" || regex.test(value)) {
                        onChange("memberNumber2", value);
                      }
                    }}
                    type="number"
                    isDisabled={memberDisabled2}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onWheel={(e) => e.target.blur()}
                  />
                  {/* <InputForm
                      placeholder={"Enter Member Number"}
                      value={memberNumber2}
                      onChange={(val: any) => {
                        onChange("memberNumber2", val);
                      }}
                      isDisabled={memberDisabled}
                    /> */}
                  <p style={{ color: "red" }}>
                    {formErrors["memberNumber2_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <div className="form-group">
                  <label>Token Number</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={"Token Number"}
                    value={tokenNumber2}
                    // onChange={(val: any) => {
                    //   onChange("tokenNumber2", val);
                    // }}
                    isDisabled={disabled}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["tokenNumber2_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <div className="form-group">
                  <label>Name</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={"Name"}
                    value={name2}
                    // onChange={(val: any) => {
                    //   onChange("name2", val);
                    // }}
                    isDisabled={disabled}
                  />
                  {/* <p style={{ color: "red" }}>{formErrors["name2_isEmpty"]}</p> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "-10px 0px 0px 0px",
                    height: "25px",
                  }}
                >
                  <SurityStatus SurStatus={surityStatus2} />
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      {/* <div className="col-lg-12 col-md-12 mt-3">
        <p>
          <b>Surity CONFIRMATION</b> (A verification link has been sent to Surity's registered Mobile No and email)
        </p>
      </div> */}
      {[
        LoanStatus.LoanModule_Draft,
        LoanStatus.LoanModule_AllSuretyApproved,
        LoanStatus.LoanModule_RejectedByInternalTeam,
        LoanStatus.LoanModule_RejectedByHrHOD,
      ].includes(approvalStatus) ||
      !memberDisabled ||
      !memberDisabled2
        ? context?.CurrentRoleId === RoleEnum.Member && (
            <div>
              <div
                className="p-2 d-flex justify-content-end"
                style={{ marginTop: 30 }}
              >
                <ButtonComponent
                  icon={""}
                  value={
                    <p>
                      <i className="far fa-times-circle"></i> Cancel
                    </p>
                  }
                  style={{ marginLeft: "10px" }}
                  className="btn btn-primary"
                  onClick={() => navigate("/LoanApprovalDashboard")}
                />
                <ButtonComponent
                  icon={"fas fa-paper-plane"}
                  value={buttonDisabled ? "Submit" : "Proceed"}
                  style={{ marginLeft: "10px" }}
                  id={"saveBtn"}
                  onClick={buttonDisabled ? onSubmit : onProceed}
                />
              </div>
            </div>
          )
        : ""}
    </div>
  );
};

export default SurityDetails;
